import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TicketSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TicketSVG;
